module.exports = __webpack_public_path__ + "static/media/obrnuti_u_ikona.4d93078b.png";